import QuestionSelector from './src/quesSelector';

/* istanbul ignore next */
QuestionSelector.install = function(Vue) {
  Vue.component(QuestionSelector.name, QuestionSelector);
};

export default QuestionSelector;
